module.exports = __webpack_public_path__ + "img/icon_s3examinationvideo.d4609c69.png";